import { createSlice } from '@reduxjs/toolkit';
import { getAllParams } from '../../../shared/helpers/WVQuery';

const ContentApprovalsReducer = createSlice({
  name: 'contentApprovals',
  initialState: {
    filters: {
      programCountry: getAllParams('filters.programCountry', { pathname: '/content-approvals' }).map(value => ({ value })),
      country: getAllParams('filters.country', { pathname: '/content-approvals' }).map(value => ({ value })),
    },
  },
  reducers: {
    updateFilters(state, action) {
      const { data } = action.payload;
      state.filters[data.property] = data.value;
    },
  },
});

export const {
  updateFilters,
} = ContentApprovalsReducer.actions;

export const updateFilter = (property, value) => async (dispatch) => {
  dispatch(updateFilters({ data: { property, value } }));
};

export default ContentApprovalsReducer.reducer;
